import cn from "classnames";
import BookIndex from "components/shared/book/list";
import List from "components/shared/list";
import { useUnreadItems } from "contexts/unreadItemsContext";
import { dateTimeToView } from "helpers/date";
import { platformNewsItemSections } from "helpers/enums";
import { paths } from "helpers/paths";
import { tableContainer } from "helpers/redux";
import lowerFirst from "lodash/lowerFirst";
import React from "react";

const Counter = (props) => {
    const { unreadItems } = useUnreadItems();
    const counter = unreadItems.news?.countBySections[lowerFirst(props.section)];

    return !!counter && <span className="news-section__count">{counter}</span>;
};

export class UserPlatformNews extends BookIndex {
    renderActions = () => {
        return (
            <div className="table-tabs m-0 mb-3">
                {platformNewsItemSections.map((item) => {
                    return (
                        <div
                            key={item.value}
                            onClick={this.changeTab.bind(this, item.value)}
                            className={cn("table-tabs__item", {
                                "table-tabs__item--active": this.props.tab === item.value,
                            })}
                        >
                            <span className="news-section--new">
                                {item.label}
                                <Counter section={item.value} />
                            </span>
                        </div>
                    );
                })}
            </div>
        );
    };

    changeTab = (tab) => {
        this.props.clearParams();
        this.props.history.replace(`${paths.userPlatformNews}/list?tab=${tab}`);
    };

    renderItem = (item, index) => {
        return (
            <tr key={item.id} onClick={() => this.props.history.push(paths.userPlatformNewsShow(item.id))}>
                <td>{this.props.params.start + index + 1}.</td>
                <td>
                    {item.isNewForUser && <span className="badge badge-pill badge-primary mr-2">Новая</span>}
                    {item.header}
                </td>
                <td>{dateTimeToView(item.createdAt)}</td>
            </tr>
        );
    };

    renderListComponent = () => {
        const { getList, tab, ...props } = this.props;
        return (
            <List
                {...props}
                EmptyList={() => (
                    <div className="list__body-empty">
                        <div className="pb-4">
                            <i className="icon-uEAC6-newspaper" />
                        </div>
                        <h4>Пока новостей нет</h4>
                    </div>
                )}
                isTable
                renderHead={() => null}
                renderRow={this.renderItem}
                columns={this.state.tableColumns}
                getList={(params) => getList({ ...params, section: tab })}
            />
        );
    };
}

export default tableContainer(UserPlatformNews, "user-platform-news");
